import { render, staticRenderFns } from "./CourtFeesCalculator.vue?vue&type=template&id=35cd0015&scoped=true&"
import script from "./CourtFeesCalculator.vue?vue&type=script&lang=js&"
export * from "./CourtFeesCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd0015",
  null
  
)

export default component.exports